import type {
  LossRateAreaSetting,
  LossRateSetting as LossRateSettingPb,
} from '@ebalance/proto/bffuser/v1/loss_rate_model_pb'
import type { ListLossRateSettingsResponse } from '@ebalance/proto/bffuser/v1/loss_rate_service_pb'
import type { Date as ProtoDate } from '@ebalance/proto/google/type/date_pb'
import type { Decimal } from '@ebalance/proto/google/type/decimal_pb'

import type { LossRateSetting, LossRateValues } from '~/constants/lossRate'

function decimalToNumber(d: Decimal | undefined): number {
  if (d === undefined || d.value === '') {
    return 0
  }
  return Number(d.value)
}

function convertSettingValues(s: LossRateSettingPb): LossRateValues {
  return {
    low: decimalToNumber(s.lowVoltageRate),
    high: decimalToNumber(s.highVoltageRate),
    extraHigh: decimalToNumber(s.extraHighVoltageRate),
  }
}

function protoDateToString(d: ProtoDate | undefined): string {
  if (d === undefined) {
    return ''
  }
  const m = String(d.month).padStart(2, '0')
  const day = String(d.day).padStart(2, '0')
  return `${d.year}-${m}-${day}`
}

function convertAreaSetting(item: LossRateAreaSetting): LossRateSetting {
  const current: LossRateValues =
    item.current !== undefined
      ? convertSettingValues(item.current)
      : { low: 0, high: 0, extraHigh: 0 }
  const currentEffectiveDate = protoDateToString(item.current?.effectiveDate)

  const next =
    item.next !== undefined
      ? {
          effectiveDate: protoDateToString(item.next.effectiveDate),
          values: convertSettingValues(item.next),
        }
      : undefined

  return {
    areaCode: item.areaCode,
    current,
    currentEffectiveDate,
    next,
  }
}

export function convertListResponse(
  resp: ListLossRateSettingsResponse,
): LossRateSetting[] {
  return resp.items.map(convertAreaSetting)
}
